export interface Pagination {
  count: number;
  ipp: number;
  page: number;
  nextPage: string | null;
}
